import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { FontIcon } from "@fluentui/react";
import React from "react";

function SortIcon(props: any) {
  if (props.order.sortOrder === null) {
    return (
      <div className="d-flex flex-column">
        <FontIcon
          iconName="ChevronUnfold10"
          style={{ fontSize: 16 }}
        />
      </div>
    );
  } else if (props.order.sortOrder === "ascend") {
    return (
      <FontIcon
        iconName="ChevronUpSmall"
        style={{ fontSize: 10 }}
      />
    );
  }
  return (
    <FontIcon
      iconName="ChevronDownSmall"
      style={{ fontSize: 10 }}
    />
  );
}

export default SortIcon;
